// extracted by mini-css-extract-plugin
export default {"wrap":"offcanvas_wrap__u7h1z"};